import React from 'react';
import { Card, CardBody } from 'reactstrap';
import DOMPurify from 'dompurify';
import { contentToHtml } from '../../utils/adfToHtml';

/**
 * Renders ticket description. Uses contentToHtml (ADF or plain) then DOMPurify.
 * This is the only permitted use of dangerouslySetInnerHTML; must stay paired with DOMPurify.
 */
export default function TicketDescription({ description }) {
  if (description == null || description === '') {
    return (
      <Card>
        <CardBody>
          <p className="text-muted mb-0">No description.</p>
        </CardBody>
      </Card>
    );
  }
  const html = contentToHtml(description);
  const sanitized = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });

  return (
    <Card>
      <CardBody>
        <div aria-label="Ticket description" dangerouslySetInnerHTML={{ __html: sanitized }} />
      </CardBody>
    </Card>
  );
}
